import { ELoadingActionTypes } from '../../actions/loading';
import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { ELoadingStatus, TLoadingStatus } from '../../types/loadingStatus';
import { TReduxActions } from '../../types/redux';

export const defaultState: TLoadingStatus = {
  pageLoader: false,
  requestStatus: ELoadingStatus.Initial,
};

export function loadingStatusReducer(state: TLoadingStatus = defaultState, action: TReduxActions): TLoadingStatus {
  switch (action.type) {
    case EPaginationActionTypes.Request:
    case EPromosActionTypes.Request:
      return {
        ...state,
        requestStatus: ELoadingStatus.Loading,
      };

    case EPaginationActionTypes.Success:
    case EPromosActionTypes.Success:
      return {
        ...state,
        requestStatus: ELoadingStatus.Success,
      };

    case EPaginationActionTypes.Failure:
    case EPromosActionTypes.Failure:
      return {
        ...state,
        requestStatus: ELoadingStatus.Failure,
      };
    case ELoadingActionTypes.SetPageLoader:
      return {
        ...state,
        pageLoader: action.payload,
      };

    default:
      return state;
  }
}
